// =====================================================
// 📁 QuotationViewModal.tsx
// =====================================================

import React from 'react';


import QuotationViewHeader from './components/QuotationViewHeader';

import QuotationViewInfo from './components/QuotationViewInfo';

import QuotationViewItemsTable from './components/QuotationViewItemsTable';

import QuotationViewTotals from './components/QuotationViewTotals';

import QuotationViewActions from './components/QuotationViewActions';
import FormModal from '../../../../Modals/FormModal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  quotation: any;
}

const QuotationViewModal: React.FC<Props> = ({
  isOpen,
  onClose,
  quotation,
}) => {
  if (!quotation) return null;

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Detalle de Cotización"
      maxWidth="max-w-6xl"
      overlayBg="black"
      zIndex="top"
    >
      <div className="flex flex-col gap-6">
        <QuotationViewHeader quotation={quotation} />

        <QuotationViewInfo quotation={quotation} />

        <QuotationViewItemsTable
          items={quotation.items}
          globalDiscountActive={Number(quotation.globalDiscountPercent || 0) > 0}
        />

        <QuotationViewTotals quotation={quotation} />

        <QuotationViewActions quotation={quotation} onClose={onClose} />
      </div>
    </FormModal>
  );
};

export default QuotationViewModal;
